import { createMRTColumnHelper, MRT_ColumnDef } from "material-react-table";
import { PersonAssociatedVersion } from "../../types/version";
import EntityReferenceComponent from "../../components/entitiesReferences/EntityReferenceComponent";
import { Box, Stack } from "@mui/material";
import { Team } from "../../types/team";
import {
  SYSTEM_TEAM_CONTRIBUTION_TYPE_LABELS,
  SystemTeamContributionTypes,
} from "../../types/versionTeam";
import {
  SYSTEM_CONTRIBUTION_TYPES_LABELS,
  SystemContributorTypes,
} from "../../types/contributor";
import { versionColumns } from "./VersionColumns";

const columnHelper = createMRTColumnHelper<PersonAssociatedVersion>();

interface PersonVersionColumnsOptions {
  showTeam?: boolean;
  showRole?: boolean;
}

export const getPersonVersionsColumns = ({
  showTeam = false,
  showRole = false,
}: PersonVersionColumnsOptions = {}): MRT_ColumnDef<
  PersonAssociatedVersion,
  any
>[] => {
  const columns: MRT_ColumnDef<PersonAssociatedVersion, any>[] = [
    ...(versionColumns as unknown as MRT_ColumnDef<PersonAssociatedVersion, any>[]),
  ];

  if (showTeam) {
    columns.unshift(
      columnHelper.accessor("teams", {
        header: "Teams",
        Cell: ({ cell }) => (
          <Stack gap={1}>
            {cell.getValue()
              ? cell
                  .getValue()
                  .map((team: Team) => (
                    <EntityReferenceComponent key={team._key} entity={team} />
                  ))
              : "-"}
          </Stack>
        ),
      })
    );
  }
  if (showRole) {
    columns.unshift(
      columnHelper.accessor("roles", {
        header: "Roles",
        Cell: ({ cell }) => (
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            {cell.getValue()
              ? (cell.getValue() as string[])
                  .map(
                    (role) =>
                      SYSTEM_TEAM_CONTRIBUTION_TYPE_LABELS[
                        role as SystemTeamContributionTypes
                      ] ||
                      SYSTEM_CONTRIBUTION_TYPES_LABELS[
                        role as SystemContributorTypes
                      ] ||
                      role
                  )
                  .join(", ")
              : "-"}
          </Box>
        ),
      })
    );
  }

  return columns;
};
